// UI-строки витрины (хром: кнопки, подписи, инструкция). Контент тарифов
// переводит бэкенд по языку покупателя; здесь — только фиксированные строки
// интерфейса. Язык приходит из /config (config().locale), выбирается в боте.

export type Lang = 'ru' | 'en';

const DICT: Record<Lang, Record<string, string>> = {
  ru: {
    search_ph: 'Поиск тарифа',
    buy: 'Купить',
    to_cart: 'В корзину',
    add_to_cart: 'Добавить в корзину',
    not_found: 'Тарифы не найдены',
    search_empty: 'Ничего не нашлось — попробуйте другой запрос',
    card_hint: 'Нажмите на карточку — подробности о тарифе и состав',
    go_to_cart: 'Перейти в корзину',
    welcome_title: 'Добро пожаловать',
    welcome_lead: 'Витрина тарифов — всё в одном месте. Три коротких шага, чтобы оформить покупку.',
    step1_title: 'Выберите тариф',
    step1_desc: 'Нажмите на карточку — откроется описание и что входит в тариф.',
    step2_title: 'Нажмите «Приобрести»',
    step2_desc: 'Тариф добавится в корзину. Можно собрать сразу несколько.',
    step3_title: 'Перейдите в корзину и оплатите',
    step3_desc: 'СБП, карта, Telegram Stars или крипта — доступ откроется сразу.',
    welcome_close: 'Понятно, начнём',
    cart_title: 'Корзина',
    cart_sub: 'Проверьте заказ и выберите способ оплаты',
    cart_empty: 'Ваша корзина пуста.',
    promo_ph: 'Промокод',
    total_label: 'Итого к оплате',
    pay: 'Оплатить',
    choose_payment: 'Выберите способ оплаты',
    choose_crypto: 'Выберите криптовалюту',
    cancel: 'Отмена',
    fee_note: '* Комиссия взимаемая платёжной системой!',
    promo_applied: 'Промокод применён! Скидка: {n}%',
    promo_invalid: 'Промокод недействителен',
    cart_empty_toast: 'Корзина пуста',
    pay_error: 'Ошибка при создании счёта',
    methods_error: 'Не удалось загрузить способы оплаты',
    no_invoice: 'Не удалось создать счёт',
    requisite: 'Реквизиты для оплаты:\n{r}\n\nДоступ откроется после зачисления.',
    mobile_only:
      '📵 Магазин доступен только с телефона.<br>Откройте его в приложении Telegram на смартфоне.',
  },
  en: {
    search_ph: 'Search plans',
    buy: 'Buy',
    to_cart: 'Add to cart',
    add_to_cart: 'Add to cart',
    not_found: 'No plans found',
    search_empty: 'Nothing found — try another query',
    card_hint: 'Tap a card for plan details and what’s inside',
    go_to_cart: 'Go to cart',
    welcome_title: 'Welcome',
    welcome_lead: 'All the plans in one place. Three quick steps to check out.',
    step1_title: 'Pick a plan',
    step1_desc: 'Tap a card to see the description and what’s included.',
    step2_title: 'Hit “Add to cart”',
    step2_desc: 'The plan drops into your cart. Grab several at once if you like.',
    step3_title: 'Open the cart and pay',
    step3_desc: 'SBP, card, Telegram Stars or crypto — access opens right away.',
    welcome_close: 'Got it, let’s go',
    cart_title: 'Cart',
    cart_sub: 'Review your order and choose how to pay',
    cart_empty: 'Your cart is empty.',
    promo_ph: 'Promo code',
    total_label: 'Total',
    pay: 'Pay',
    choose_payment: 'Choose a payment method',
    choose_crypto: 'Choose a cryptocurrency',
    cancel: 'Cancel',
    fee_note: '* Fee charged by the payment provider',
    promo_applied: 'Promo applied! Discount: {n}%',
    promo_invalid: 'Invalid promo code',
    cart_empty_toast: 'Cart is empty',
    pay_error: 'Couldn’t create the invoice',
    methods_error: 'Couldn’t load payment methods',
    no_invoice: 'Couldn’t create the invoice',
    requisite: 'Payment details:\n{r}\n\nAccess opens once the payment lands.',
    mobile_only:
      '📵 Available on your phone only.<br>Open it in the Telegram app on your smartphone.',
  },
};

let current: Lang = 'ru';

export function setLang(l: string | undefined): void {
  current = l === 'en' ? 'en' : 'ru';
}

export function t(key: string, vars?: Record<string, string | number>): string {
  let s = DICT[current][key] ?? DICT.ru[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) s = s.replace(`{${k}}`, String(v));
  }
  return s;
}

/** Проставляет фиксированные строки в статичную разметку по data-атрибутам. */
export function applyStaticI18n(root: ParentNode = document): void {
  root.querySelectorAll<HTMLElement>('[data-i18n]').forEach((el) => {
    const k = el.dataset.i18n;
    if (k) el.textContent = t(k);
  });
  root.querySelectorAll<HTMLInputElement>('[data-i18n-ph]').forEach((el) => {
    const k = el.dataset.i18nPh;
    if (k) el.placeholder = t(k);
  });
  root.querySelectorAll<HTMLElement>('[data-i18n-aria]').forEach((el) => {
    const k = el.dataset.i18nAria;
    if (k) el.setAttribute('aria-label', t(k));
  });
}
